module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/fbca1281c2f4b02239d564167141c614.svg";